import styled, { keyframes } from 'styled-components';

const spin = keyframes`to { transform: rotate(360deg); }`;

export const Spinner = styled.span<{ size?: number }>`
  display: inline-block;
  width: ${(p) => p.size ?? 16}px;
  height: ${(p) => p.size ?? 16}px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
  vertical-align: middle;
`;

export default Spinner;
